import { render, staticRenderFns } from "./goodCenter.vue?vue&type=template&id=356969c0&scoped=true&"
import script from "./goodCenter.vue?vue&type=script&lang=js&"
export * from "./goodCenter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./goodCenter.vue?vue&type=style&index=0&id=356969c0&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "356969c0",
  "72c47f27"
  
)

export default component.exports